module.exports = __webpack_public_path__ + "media/assets/faria_products/Pamoja-dae284dde26e8bb131cf94dc2500cdedbcc2a141a5b78ad8705e84dc7c65ae08.svg";